import { baseUrl } from "./api";

export const getImageUrl = (imageKey, imageType) =>
  `${baseUrl}/images/${imageKey}?imageType=${imageType}`;
